/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description npi constants
 */

/**
 * NPI code length for validation
 */
const NPI_CODE_LENGTH = 10;

/**
 * NPI status
 */
const PROVIDER_STATUS = {
	active: {
		title: 'Enabled',
		value: true,
		color: 'green',
	},
	inactive: {
		title: 'Disabled',
		value: false,
		color: 'red',
	},
};

/**
 * entity type
 */
const PROVIDER_TYPE = {
	provider: {
		registryCode: 'NPI-1' as Provider.IRegistryType,
		registryNumber: 1 as Provider.IRegistryNumber,
		npiButtonType: 'provider' as Provider.IButtonType,
		title: 'Provider',
		providerType: 'Practitioner' as Provider.IProviderType,
		ekycType: 3 as Provider.IeKYCType,
	},
	location: {
		registryCode: 'NPI-2' as Provider.IRegistryType,
		registryNumber: 2 as Provider.IRegistryNumber,
		npiButtonType: 'locations' as Provider.IButtonType,
		title: 'Organization',
		providerType: 'Organization' as Provider.IProviderType,
		ekycType: 2 as Provider.IeKYCType,
	},
};

const PROVIDER_TYPE_OPTIONS = [
	{
		label: 'Provider',
		value: PROVIDER_TYPE.provider.providerType,
	},
	{
		label: 'Organization',
		value: PROVIDER_TYPE.location.providerType,
	},
];

const PROVIDER_SEARCH_FIELDS = {
	name: {
		key: 'name',
		label: 'Provider Name',
		placeHolder: 'E.g.: John Doe',
	},
	npi: {
		key: 'npi',
		label: 'NPI',
		placeHolder: 'E.g.: 1234567890',
	},
	providerType: {
		key: 'providerType',
		label: 'NPI Type',
		placeHolder: 'Select an NPI Type',
	},
	filterButtons: {
		clear: 'Clear',
		submit: 'Search',
		apply: 'Apply',
	},
};

export { PROVIDER_STATUS, NPI_CODE_LENGTH, PROVIDER_TYPE, PROVIDER_TYPE_OPTIONS, PROVIDER_SEARCH_FIELDS };
